import PropTypes from 'prop-types'
import React from 'react'
import { pluralise } from '../helpers/formatting'
import { markdownItemNodes } from '../helpers/markdown'
import {
  projectsPageMetadata,
  projectsResourceTitle,
} from '../helpers/siteMetadata'
import Metadata from '../shared/Metadata'
import Page from '../shared/Page'
import ProjectsList from './ProjectsList'

const ProjectsPage = ({ data }) => (
  <Page title={pluralise(projectsResourceTitle(data))}>
    <Metadata {...projectsPageMetadata(data)} />
    <p>
      Over the years, I've worked on a wide variety of technologies and
      platforms, but always with an emphasis on data visualisation, media-rich, interactive and
      realtime applications. Here are some examples.
    </p>
    <ProjectsList projects={markdownItemNodes(data)} />
  </Page>
)

ProjectsPage.propTypes = {
  data: PropTypes.object.isRequired,
}

export default ProjectsPage



// WEBPACK FOOTER //
// ./src/components/ProjectsPage/ProjectsPage.jsx